import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=1da3715f&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=1da3715f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3715f",
  null
  
)

export default component.exports